import Breadcrumb from "@/components/base/Breadcrumb";
import ScrollTopButton from "@/components/base/ScrollTopButton";
import JsonLd from "@/components/feature/JsonLd";
import PrinciplesSection from "@/components/feature/PrinciplesSection";
import VoiceSection from "@/components/feature/VoiceSection";
import useSeo from "@/hooks/useSeo";
import { siteInfo } from "@/mocks/site";
import BrandIntro from "@/pages/about/components/BrandIntro";
import ContactSection from "@/pages/about/components/ContactSection";
import WorkflowSection from "@/pages/about/components/WorkflowSection";

const siteUrl = "https://baoliaoqianxian.example.com/";

export default function About() {
  useSeo({
    title: "关于我们 - 独家爆料网站定位、内容原则与线索投递",
    description:
      "了解独家爆料的网站定位、发展理念、内容原则与时间线制作流程，并通过线索投递表单联系我们，补充事件反转与后续进展的最新材料。",
    keywords: "独家爆料,关于我们,内容原则,线索投递,事件时间线",
    canonicalPath: "/about",
    ogType: "website",
  });

  return (
    <>
      <JsonLd
        id="about-page"
        data={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: `关于${siteInfo.name}`,
          url: `${siteUrl}about`,
          inLanguage: "zh-CN",
          description: siteInfo.description,
          breadcrumb: {
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: siteUrl },
              { "@type": "ListItem", position: 2, name: "关于我们", item: `${siteUrl}about` },
            ],
          },
        }}
      />
      <JsonLd
        id="contact-page"
        data={{
          "@context": "https://schema.org",
          "@type": "ContactPage",
          name: `联系${siteInfo.name}`,
          url: `${siteUrl}about`,
          inLanguage: "zh-CN",
          mainEntity: {
            "@type": "Organization",
            name: siteInfo.name,
            email: siteInfo.contactEmail,
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "editorial",
              email: siteInfo.contactEmail,
              availableLanguage: ["zh-CN"],
            },
          },
        }}
      />

      <section className="border-b border-background-200 paper-grain">
        <div className="max-w-shell mx-auto px-4 md:px-6 py-8 md:py-12">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
          <div className="mt-5 max-w-3xl">
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.3em] text-primary-700">
              <span className="w-8 h-px bg-primary-400" />
              关于我们
            </span>
            <h1 className="mt-4 font-heading text-3xl md:text-4xl font-black leading-snug tracking-tight text-foreground-950">
              做一条能看懂的独家爆料时间线
            </h1>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              {siteInfo.slogan}。我们相信，一条爆料的完整过程比某一个瞬间的结论更有价值。
            </p>
          </div>
        </div>
      </section>

      <BrandIntro />
      <PrinciplesSection />
      <WorkflowSection />
      <VoiceSection />
      <ContactSection />
      <ScrollTopButton />
    </>
  );
}